import { html, render } from "lit";
import ElementController from "../base-controllers/ElementController.js";
import { FormEvent } from "../components/form/constants.js";
import { getData } from "../utils/dom.js";
import { nextAnimationFrame } from "../utils/js.js";
import { confirmCardSetup, createCard } from "../utils/stripe.js";
/**
 * Confirm card setup from card field.
 */
class AddCardForm extends ElementController {
    constructor() {
        super(...arguments);
        /**
         * Stop form from sending, so we first can confirm card setup, and then
         * send form.
         *
         * @param event - The before send form event.
         */
        this.beforeFormSend = async (event) => {
            if (event.cancelable) {
                event.preventDefault();
                const { setupIntent, error } = await confirmCardSetup(this.stripe, this.card, this.cardInputNode, getData(this.root, "setup-client-secret"));
                if (error) {
                    this.dispatch(this.root, FormEvent.enableFields);
                    this.dispatch(this.root, FormEvent.showErrors);
                }
                else {
                    this.cardNativeInputNode.value = setupIntent.payment_method;
                    this.dispatch(this.root, FormEvent.send, { detail: false });
                }
            }
        };
        /**
         * Create card element
         */
        this.createCard = () => {
            this.card = createCard(this.stripe, this.cardInputNode);
        };
        /**
         * Mount card element on node
         */
        this.mountCard = () => {
            this.card.mount('input[type="text"][name$=card] .stripe-card-element');
        };
    }
    async init() {
        // @ts-expect-error
        this.stripe = window.Stripe(window._APP_.stripeKey);
        await this.createCardElementWrapper();
        this.createCard();
        this.mountCard();
    }
    destroy() {
        this.card.unmount();
    }
    get cardInputNode() {
        return this.root.querySelector('input[type="text"][name$=card]');
    }
    get cardNativeInputNode() {
        return this.root.querySelector('input[type="text"][name$=card] input.native-input');
    }
    get root() {
        return super.root;
    }
    async createCardElementWrapper() {
        // Let input render
        await nextAnimationFrame();
        render(html `
        <div class="stripe-card-element"></div>
      `, this.root.querySelector('input[type="text"][name$=card] .native-wrapper'));
    }
}
AddCardForm.id = "AddCardForm";
AddCardForm.binds = {
    root: [[FormEvent.beforeSend, "beforeFormSend"]],
};
export default AddCardForm;
//# sourceMappingURL=AddCardForm.js.map